import Vue from "vue";
import Buefy from "buefy";

import Carousel from "./App.vue";

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})
Vue.use(Carousel)

if(document.getElementById("carouselApp")){
    new Vue({
        render:h=>h(
            Carousel,{
                props:{
                    dataUrl:document.getElementById("carouselApp")
                        .getAttribute("dataUrl")
                }
            }
        )
    }).$mount("#carouselApp")
}